<template>
    <div class="h-100 content__page" v-bind="$attrs">
        <ul v-for="item in groupByKeys" :key="item">
            <div class="revenue__date__header">
                {{ $format_date(item) }}
            </div>

            <li
                v-for="meeting in groupedListByDate[item]" :key="meeting._id" 
                class="zm__list__item"
                :class="{ 'active': meeting._id === currentMeetingId }"
                @click="$emit('fetch-single-meeting', meeting._id)" 
            >
                <div class="zm__list__item__text">
                    <div class="flex align-items-center justify-content-between">
                        <div class="zm__list__item__title">
                            {{ meeting.title }}
                        </div>

                        <Status 
                            type="meeting" 
                            :value="meeting.status || '-'" 
                            :is-table="false"
                        />
                    </div>

                    <div class="mt--10">
                        <div class="flex align-items-center">
                            <div class="zm__list__item__icon">
                                <IconSvg name="calendar-event" width="16px" height="16px" fill="#70878D" />
                            </div>
                            <p class="text--sm text-gray-800">
                                {{ formatDateRange(meeting?.startDate, meeting?.endDate) }}
                            </p>
                        </div>
                        <p class="text-gray-600 text--xs mt--5">
                            {{ meeting.attendeesCount }} {{ meeting.attendeesCount === 1 ? 'attendee' : 'attendees' }} | {{ meeting.notesCount }} {{ meeting.notesCount === 1 ? 'note' : 'notes' }}
                        </p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { 
    IconSvg, 
    Status,
} from "@/components/ui/index";
import { formatDateRange, groupList } from "@/utils/helpers";

export default {
    name: "MeetingList",

    components: {
        IconSvg,
        Status,
    },

    props: {
        items: { type: Array, default: () => [] },
        currentMeetingId: { type: String, default: ""},
        type: { type: String, default: ""},
    },

    emits: ["fetch-single-meeting"],

    computed: {
        groupedListByDate() {
            if (!this.items.length) {
                return [];
            }

            const arr = groupList(this.items, (item) => {
                // createdAt comes in form of timestamp from API
                // Convert to YYYY-MM-DD
                const date = new Date(item.startDate);

                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();

                const filter = `${year}-${month}-${day}`;

                return filter;
            });

            return Object.fromEntries(arr);
        },

        groupByKeys() {
            return Object.keys(this.groupedListByDate) || [];
        },
    },

    methods: {
        formatDateRange,

    },
};
</script>